// extracted by mini-css-extract-plugin
export default {"resultContainer":"ResultComponent_resultContainer__Os24J"};